"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportOrderFinish = reportOrderFinish;
exports.reportOrderRefund = reportOrderRefund;
exports.reportOrderSteal = reportOrderSteal;
var _adminOperationReport = require("@/utils/adminOperationReport");
/**
 * 【操作埋点】订单管理模块上报方法
 * 实施时间：2026-05-25
 * 说明：结束订单/退款/缩水恢复（$get 场景需页面手动调用）
 */

/**
 * 结束订单埋点上报
 * @param {string} orderId - 订单号
 * @param {string} reason - 结束原因
 */
function reportOrderFinish(orderId) {
  var reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '结束订单',
    content: "\u5F3A\u5236\u7ED3\u675F\u8BA2\u5355\u53F7\uFF1A".concat(orderId).concat(reason ? '，原因：' + reason : ''),
    operation_id: 'pc_order_finish_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_order_finish_1');
}

/**
 * 订单退款埋点上报
 * @param {string} orderId - 订单号
 * @param {number} amount - 退款金额
 * @param {string} reason - 退款原因
 */
function reportOrderRefund(orderId, amount) {
  var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '订单退款',
    content: "\u8BA2\u5355\u53F7 ".concat(orderId, " \u9000\u6B3E ").concat(amount, " \u5143").concat(reason ? '，原因：' + reason : ''),
    operation_id: 'pc_order_refund_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_order_refund_1');
}

/**
 * 处理掉单埋点上报
 * @param {string} orderId - 订单号
 */
function reportOrderSteal(orderId) {
  var meta = (0, _adminOperationReport.buildAdminOperationReportMeta)({
    operation_option: '处理掉单',
    content: "\u5904\u7406\u6389\u5355\uFF0C\u8BA2\u5355\u53F7\uFF1A".concat(orderId),
    operation_id: 'pc_order_steal_1'
  });
  return (0, _adminOperationReport.reportAdminOperation)(meta, 'pc_order_steal_1');
}